import { log } from "../../ui/log";
import { doRequest } from "./apiRequest";
import {
  type HotelRawData,
  isValidHotelData,
  mapToHotelRawData,
} from "./types-hotel";

export type SearchHotelsParams = {
  latitude: number;
  longitude: number;
  adults_number: number;
  checkin_date: string;
  checkout_date: string;
};

export async function fetchHotelsApi(
  searchParams: SearchHotelsParams,
): Promise<HotelRawData[]> {
  const result = await doRequest("v1/hotels/search-by-coordinates", {
    include_adjacency: true,
    order_by: "popularity",
    room_number: 1,
    locale: "en-gb",
    page_number: 0,
    filter_by_currency: "EUR",
    categories_filter_ids: "reviewscorebuckets::80,free_cancellation::1",
    units: "metric",
    ...searchParams,
  });

  const validHotels: HotelRawData[] = [];

  log.network("Got raw hotels", result);

  result.result.forEach((hotelRawData: unknown) => {
    if (isValidHotelData(hotelRawData)) {
      validHotels.push(mapToHotelRawData(hotelRawData));
    }
  });

  log.network("Got mapped valid hotels", validHotels);

  return validHotels;
}
